module.exports = __webpack_public_path__ + "img/telegram-icon.7ec4c57d.svg";